export interface GetPreferenceAssignReserveListRequest {
  id: number
  collectionNo: string
  _force: boolean
}

export function GetPreferenceAssignReserveListRequestToJSON(
  value: GetPreferenceAssignReserveListRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined,
    _force: value._force ?? undefined
  }
}
